/**
 * This file defines a set of display constants for EMC
 */
export var EMCDisplayMessageConsts;
(function (EMCDisplayMessageConsts) {
    EMCDisplayMessageConsts["Arm"] = "Arm";
    EMCDisplayMessageConsts["ArmPowerCableCheck"] = "Arm is not enabled, check the power cable and EtherCAT connection";
    EMCDisplayMessageConsts["CassetteClose"] = "Cassette close detected";
    EMCDisplayMessageConsts["CassetteDetected"] = "Cassette present";
    EMCDisplayMessageConsts["CassetteNotDetected"] = "Cassette absent";
    EMCDisplayMessageConsts["CassetteOpen"] = "Cassette open detected";
    EMCDisplayMessageConsts["ControlSide"] = "Control Side:";
    EMCDisplayMessageConsts["DistalDefineSensePresent"] = "Distal sensor present";
    EMCDisplayMessageConsts["DistalDefineSenseAbsent"] = "Distal sensor removed";
    EMCDisplayMessageConsts["Drive"] = "Drive";
    EMCDisplayMessageConsts["Drive1"] = "Drive 1";
    EMCDisplayMessageConsts["Drive2"] = "Drive 2";
    EMCDisplayMessageConsts["Drive3"] = "Drive 3";
    EMCDisplayMessageConsts["Drive4"] = "Drive 4";
    EMCDisplayMessageConsts["DrivePowerCableCheck"] = "Drive is not enabled, check the power cable and EtherCAT connection";
    EMCDisplayMessageConsts["EmcModeDuration"] = "The duration of EMC Test was";
    EMCDisplayMessageConsts["ESTOPDetected"] = "EStop is detected";
    EMCDisplayMessageConsts["ESTOPNotDetected"] = "EStop is not detected";
    EMCDisplayMessageConsts["EstopPressed"] = "Estop switch is pressed";
    EMCDisplayMessageConsts["Fault"] = "Fault";
    EMCDisplayMessageConsts["Frame"] = "Frame";
    EMCDisplayMessageConsts["FaultorWarning"] = "Fault/warning related to";
    EMCDisplayMessageConsts["IdleMonitorDuration"] = "The duration of Idle monitor was";
    EMCDisplayMessageConsts["Mins"] = "mins";
    EMCDisplayMessageConsts["Module"] = "Module";
    EMCDisplayMessageConsts["ModuleEnable"] = "all modules are not enabled after 20s";
    EMCDisplayMessageConsts["MsgCleared"] = "Cleared:";
    EMCDisplayMessageConsts["P1P2LockedArm"] = "Arm Lock Button Status from Arm changed unexpectedly";
    EMCDisplayMessageConsts["P1P2UnLockedArm"] = "Arm Unlock Button Status from Arm changed unexpectedly";
    EMCDisplayMessageConsts["P1P2LockedFrame"] = "Arm Lock Button Status from Frame changed unexpectedly";
    EMCDisplayMessageConsts["P1P2UnLockedFrame"] = "Arm Unlock Button Status from Frame changed unexpectedly";
    EMCDisplayMessageConsts["PatientSide"] = "Patient Side:";
    EMCDisplayMessageConsts["ProximalSensePresent"] = "Proximal sensor present";
    EMCDisplayMessageConsts["ProximalSenseAbsent"] = "Proximal sensor removed";
    EMCDisplayMessageConsts["RcFaultPrefix"] = "RC";
    EMCDisplayMessageConsts["PimFaultPrefix"] = "PIM";
    EMCDisplayMessageConsts["StartIdleMonitor"] = "Idle monitor started";
    EMCDisplayMessageConsts["StartEmcLogs"] = "EMC Test started";
    EMCDisplayMessageConsts["StopIdleMonitor"] = "Idle monitor stopped";
    EMCDisplayMessageConsts["SysErrorFault"] = "Fault related to system error";
    EMCDisplayMessageConsts["TimeOutFault"] = "Time out fault";
    EMCDisplayMessageConsts["TrackForwardPresent"] = "Track forward is detected";
    EMCDisplayMessageConsts["TrackForwardAbsent"] = "Track forward is not detected";
    EMCDisplayMessageConsts["Warning"] = "Warning";
})(EMCDisplayMessageConsts || (EMCDisplayMessageConsts = {}));
//# sourceMappingURL=EMCDisplayMessageConsts.js.map